var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00593 14.2844C5.11061 14.2844 6.00612 13.3889 6.00612 12.2843C6.00612 11.1796 5.11061 10.2841 4.00593 10.2841C2.90126 10.2841 2.00574 11.1796 2.00574 12.2843C2.00574 13.3889 2.90126 14.2844 4.00593 14.2844ZM4.00593 15.7628C5.92711 15.7628 7.48452 14.2054 7.48452 12.2843C7.48452 10.3631 5.92711 8.80566 4.00593 8.80566C2.08476 8.80566 0.527344 10.3631 0.527344 12.2843C0.527344 14.2054 2.08476 15.7628 4.00593 15.7628Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.921 14.2844C16.0256 14.2844 16.9212 13.3889 16.9212 12.2843C16.9212 11.1796 16.0256 10.2841 14.921 10.2841C13.8163 10.2841 12.9208 11.1796 12.9208 12.2843C12.9208 13.3889 13.8163 14.2844 14.921 14.2844ZM14.921 15.7628C16.8421 15.7628 18.3996 14.2054 18.3996 12.2843C18.3996 10.3631 16.8421 8.80566 14.921 8.80566C12.9998 8.80566 11.4424 10.3631 11.4424 12.2843C11.4424 14.2054 12.9998 15.7628 14.921 15.7628Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.22371 5.58815C10.3284 5.58815 11.2239 4.69264 11.2239 3.58797C11.2239 2.48329 10.3284 1.58778 9.22371 1.58778C8.11903 1.58778 7.22352 2.48329 7.22352 3.58797C7.22352 4.69264 8.11903 5.58815 9.22371 5.58815ZM9.22371 7.06656C11.1449 7.06656 12.7023 5.50914 12.7023 3.58797C12.7023 1.66679 11.1449 0.109375 9.22371 0.109375C7.30254 0.109375 5.74512 1.66679 5.74512 3.58797C5.74512 5.50914 7.30254 7.06656 9.22371 7.06656Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 1.09078,
    y1: 14.587,
    x2: 6.30866,
    y2: 9.3691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80B5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#BA59FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4695FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 12.0058,
    y1: 14.587,
    x2: 17.2237,
    y2: 9.3691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80B5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#BA59FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4695FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 6.30855,
    y1: 5.89069,
    x2: 11.5264,
    y2: 0.672809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80B5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#BA59FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4695FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.d4935df6d1028257b892ee64f01475c6.svg";
export { ForwardRef as ReactComponent };